import { useState, useEffect } from "react";

const useTimer = (initialSeconds) => {
    const [seconds, setSeconds] = useState(initialSeconds);
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        if (seconds <= 0) { setIsExpired(true); return; }
        const t = setTimeout(() => setSeconds(s => s - 1), 1000);
        return () => clearTimeout(t);
    }, [seconds]);

    const reset = () => {
        setSeconds(initialSeconds);
        setIsExpired(false);
    };

    const formatted = `${Math.floor(seconds / 60).toString().padStart(2, "0")}:${(seconds % 60).toString().padStart(2, "0")}`;

    return { formatted, isExpired, reset };
};

export default useTimer;